const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/support/tickets/$ticketId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { type UpdateSupportTicketRequest } from "@/types/api/support";
import { createFileRoute } from "@tanstack/react-router";
import { type ReactNode } from "react";
export const Route = createFileRoute("/support/tickets/$ticketId")({
  beforeLoad: args => requirePermission(Permissions.Support.ViewTickets, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/**
 * Errors the requester hit from 24 hours before the ticket was opened until now
 * (Application Insights), to see what went wrong without asking them.
 */

/** Reply or internal note, optionally setting status in the same step. */